import axios from "axios";
import authHeader from "./auth-header";
import { checkEnvType } from "src/helper";
import { setMessage } from "src/slices/message";
import store from '../store'

const isDevelopment = checkEnvType();
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_DEV_URL
  : process.env.REACT_APP_API_PROD_URL;

  
const instance = axios.create({
  baseURL: API_URL,
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = (error.response && error.response.data && error.response.data.message) ||
      error.message || error.toString();
    store.dispatch(setMessage({ message, isError: true }));
    return Promise.reject(error);
  }
);
const addBeauty = async (
  title,
  url,
  category,
  description,
  image,
  isActive
) => {
  return await axios
    .post(
      API_URL + "admin/addbeauty",
      {
        title,
        url,
        category,
        description,
        image,
        isActive,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const addInnerBeauty = async (
  title,
  url,
  category,
  content,
  innerImage,
  price,
  id
) => {
  return await axios
    .patch(
      API_URL + `admin/addinnerbeauty/${id}`,
      {
        title,
        url,
        category,
        content,
        innerImage,
        price,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getBeauty = async () => {
  return await instance
    .get(API_URL + "admin/beauty", {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

const updateBeauty = async (id, isActive) => {
  return await axios
    .patch(
      API_URL + `admin/updatebeauty/${id}`,
      { isActive },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const updateContent = async (id, content) => {
  return await axios
    .patch(
      API_URL + `admin/updatebeautycontent/${id}`,
      { content },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const updateBeautyData = async (
  id,
  title,
  url,
  category,
  description,
  image,
  oldImage
) => {
  return await axios
    .put(
      API_URL + `admin/updatebeauty/${id}`,
      {
        title,
        url,
        category,
        description,
        image,
        oldImage,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const deleteBeauty = async (id) => {
  return await axios
    .delete(API_URL + `admin/deletebeauty/${id}`, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

const deleteInnerBeauty = async (id, beautyId, oldImage) => {
  return await axios
    .patch(
      API_URL + `admin/deleteinnerbeauty/${id}`,
      {
        beautyId,
        oldImage,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const beautyService = {
  addBeauty,
  addInnerBeauty,
  getBeauty,
  updateBeauty,
  updateBeautyData,
  updateContent,
  deleteBeauty,
  deleteInnerBeauty,
};
export default beautyService;
